import { IShape } from "../interfaces/IShape";

export abstract  class Shape implements IShape {
    id: string = crypto.randomUUID();
    width: number = 50;
    height: number= 50;
    positionX: number = 0;
    positionY: number= 0;
    rotate: number = 0;
    color: string = "green";
    rx: number = 12.5;
    ry: number = 12.5;
    strokeColor: string = "black";
    strokeDashArray!: [number, number];
    points: string="";
    isSelected: boolean = false;
    name: string='';
    teamId!: number;


    
    setName(name: string): IShape{
        this.name = name;
        return this;
    }
    
}